import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { PdpInquiryModalComponent } from './pdp-inquiry-modal.component';

export const pdpInquiryModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.PDP_INQUIRY]: {
      inlineRoot: true,
      component: PdpInquiryModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
      dialogOptions: {
        onTop: true,
      },
    },
  },
};
